import styled from 'styled-components';
import type { ProductMaterial } from '@storefront/lib-global/codegen/types';
import { TypographyStyles, colours, spacing } from '@storefront/lib-global/stylings';

type MaterialsTableProps = {
  materials: ProductMaterial[] | undefined;
};

const S = {
  Container: styled.ul`
    padding: 0;
  `,
  Item: styled.li<{ $isOdd: boolean }>`
    background-color: ${({ $isOdd }) => ($isOdd ? colours.LIGHTER_GREY : colours.WHITE)};
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: ${spacing.XXXS} ${spacing.XS};
    ${TypographyStyles.Body.Small.Regular}
  `,
};

const getValue = (value: string) => {
  switch (value) {
    case 'true':
      return 'Yes';
    case 'false':
      return 'No';
    default:
      return value;
  }
};

export function MaterialsTable({ materials }: MaterialsTableProps) {
  return (
    <S.Container>
      {materials?.map(({ label, value }, i) => (
        <S.Item key={`${label}-${value}`} $isOdd={i % 2 === 0}>
          <span>{label}</span> <span>{getValue(value)}</span>
        </S.Item>
      ))}
    </S.Container>
  );
}
